import React, { useState, useEffect, useRef, useMemo } from 'react';
import classNames from 'classnames';
import axios from './src/_common/axios-config';
import i18n from "i18next";
import { Message } from 'primereact/message';
import useWindowDimensions from './utils/useWindowDimensions';
import { AppContext } from './src/_templates/Contexts';
import { Outlet, useLocation, matchPath } from 'react-router-dom';

const App = ({ history }) => {
    const currentLocation = useLocation();
    const appMessages = useRef(null);
    const appToast = useRef(null);
    const appWarningToast = useRef(null);
    //import viewdata from server side don't touch it
    const serverAppConfig = useMemo(() => { return window.__INITIAL_DATA__; }, []);

    // Add global axios interceptors
    axios.interceptors.request.use(function (config) {
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });

    axios.interceptors.response.use(function (response) {
        //check if respone send expired
        if (response.data.expired) {
            setTimeout(() => {
                dispatch({ type: 'setTokenExpired', value: true });
            }, 1000);
        }

        //Successful response, do nothing here
        return response;
    }, function (error) {
        let errorMessage = '';

        console.log(error);
        console.log(error.response);

        if (!error.response) return Promise.reject(error);

        if (error.response.data.expired) {
            setTimeout(() => {
                dispatch({ type: 'setTokenExpired', value: true });
            }, 1000);
        }

        //Manage error response
        if (error.response && error.response.data && error.response.data.errorMessage) {
            errorMessage = error.response.data.errorMessage;
        } else if (error.message) {
            errorMessage = error.message;
        } else {
            errorMessage = error;
        }

        if (errorMessage.includes("Errorcode_001:")) {
            dispatch({ type: 'datashareError', value: true });
        } else if (errorMessage.includes("Errorcode_002:")) {
            dispatch({ type: 'datashareInvalid', value: true });
        }

        return Promise.reject(errorMessage);
    });

    //need to update when add route into index.js
    //change tab title here
    const routes = [
        { path: "/", name: "Home" },
        { path: "/login", name: "Login" },
        { path: "/resetpwd", name: "Reset Password" },
        { path: "/invitation", name: "Invitation" },
        { path: "/authentication", name: "Authentication" },
        { path: "/authentication/twoFactorAuth", name: "Two-Factor Authentication" },
        { path: "/authentication/forgotPwd", name: "Forgot Password" },
        { path: "/authentication/selectCompanyPlant", name: "Select Company/Plant" },
        { path: "/signup/signupAccount", name: "Sign Up Account" },
    ];

    function getRouteName() {   
        for (const route of routes) {
            if (matchPath({ path: route.path, end: true }, currentLocation.pathname)) {
                return ` - ${route.name}`;
            }
        }
        return '';
    }

    useEffect(() => {
        if (serverAppConfig) {
            document.title = `${serverAppConfig.siteTitle}${getRouteName()}`
        }

    }, [currentLocation])

    const clearMessages = () => {
        appMessages.current.clear();
    };

    const addMessage = (sticky, severity, message) => {
        appMessages.current.show({ sticky: sticky, closable: true, severity: 'error', detail: message, life: 8000 });
    };

    const inviteMessage = (severity, message) => {
        showToast(severity, 'Invited company result.', message, "top-right", 5000);
    };

    const topupMessage = (severity, title, message) => {
        showToast(severity, title, message, "top-right", 5000);
    };

    const showToast = (severity = 'success', summary = '', detail = '', position = "top-right", life = 3000) => {
        if (position === "top-center") {
            appWarningToast.current.show({
                severity: severity,
                summary: summary,
                detail: detail,
                life: life
            });
        }
        else {
            appToast.current.show({
                severity: severity,
                summary: summary,
                detail: detail,
                life: life
            });
        }
    };

    const showToastDataDeleted = () => {
        showToast('success', i18n.t("app:gen.success_title"), i18n.t("app:gen.data_deleted"));
    };

    const showToastDataUpdated = () => {
        showToast('success', i18n.t("app:gen.success_title"), i18n.t("app:gen.data_updated"));
    };

    const handleAxiosException = (error, logOnly) => {
        //Log error
        console.error(error);

        //Automatically close loading data panel on error
        dispatch({ type: 'setLoadingOverlay', value: false });

        //if (!logOnly) {
        //Show error message
        appMessages.current.show({ sticky: true, closable: true, severity: 'error', detail: i18n.t("app:gen.error_axios_generic") + ": " + error, life: 8000 });
        //}
    };


    return (
        <AppContext.Provider value={
            {
                handleAxiosException: handleAxiosException, clearMessages: clearMessages, addMessage: addMessage, showToast, inviteMessage: inviteMessage, topupMessage: topupMessage,
                showToastDataDeleted: showToastDataDeleted, showToastDataUpdated: showToastDataUpdated
            }
        }>
            <div className="login-container">
                <div className="login-middle">
                    <div>
                        <p className="logo-center" style={{ height: "90px", marginBottom: "4px" }}>
                            {serverAppConfig && <img src={serverAppConfig.siteLogo} style={{ height: "90px", verticalAlign: "middle" }} alt="Logo" />}
                        </p>
                    </div>
                        <Outlet />
                </div>
            </div>
        </AppContext.Provider>
    );

}

export default App;